module.exports = __webpack_public_path__ + "img/home-industry-body-2.681c6137.png";